import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.catalog.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import List from './List';
import Error from '../../../dialogs/Error';
import { AddIcon } from '../../../../images/icons/WrapSvg';

class Catalogs extends React.Component {
    state = {
        hide: false,
        open: undefined,
    };

    constructor(props) {
        super(props);
        props.loadCatalogs();
    }

    componentDidMount() {
        this.props.setInventoryWindow("catalogs");
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = (event) => {
        this.props.history.push('/manage/new_catalog');
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '62') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={3} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div className={'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'}>
                            <List />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Catalogs.propTypes = {
    catalog_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        catalog_is_loading: state.catalog_is_loading,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, inventory), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Catalogs));



// WEBPACK FOOTER //
// ./src/components/complex/manage/catalogs/Index.js